/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/subscribeOn */
import{operate as n}from"rxjs/dist/esm/internal/util/lift";function c(r,o=0){return n((t,e)=>{e.add(r.schedule(()=>t.subscribe(e),o))})}export{c as subscribeOn};
//# sourceMappingURL=subscribeOn.mjs.map